export default "__VITE_ASSET__l8q$w6ZU__"